// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.web-portal {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.web-portal .form-input > input {
  padding: 6px !important;
}
.web-portal .form-check-input-custom {
  display: flex;
  align-items: center;
}
.web-portal-title {
  font-size: 1.5em;
  font-weight: bold;
}
.web-portal-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.web-portal-form {
  display: flex;
  flex-direction: column;
}
.web-portal-form-layout {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 0.5em;
}
.web-portal .form-action {
  align-self: flex-start;
  margin-top: 0.3em;
}

.web-portal-access-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex: 1 1;
}

.web-portal-check-group {
  display: flex;
  justify-content: flex-start;
  align-items: space-between;
}

.web-portal-access-group-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: space-between;
}

.web-portal-access-label {
  font-weight: bold;
}

.web-portal-sr-check-group-col .form-check {
  margin: 0 !important;
}
.web-portal-sr-check-group-col {
  display: grid;
  grid-auto-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  gap: 0.1em 5em;
}

.web-portal-sr-check-group-col-header .form-check {
  margin: 0 !important;
}
.web-portal-sr-check-group-col-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 0.5em;
  margin-bottom: 0.5em;
}

.web-portal-sr-check-group-col-header span,
.web-portal-sr-check-group-col-header label {
  white-space: nowrap;
}

.blocked-label {
  margin-top: 0.5rem;
  margin-left: 1rem;
  font-size: 0.8rem;
  color: gray;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  border-radius: 0.2rem;
  background-color: #E6E6E6;
}

.hard-delete-user-button {
  text-decoration: none;
  color: #8f003c;
  padding: 0;
}

.hard-delete-user-button:hover {
  color: #8f003c;
}

.hard-delete-user-button:focus {
  color: #8f003c;
}

.hard-delete-user-button p {
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/views/webPortalUsers/webPortalUsersForm/webPortalUserForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,uBAAA;AAAF;AAGC;EACC,aAAA;EACE,mBAAA;AADJ;AAIC;EACC,gBAAA;EACA,iBAAA;AAFF;AAKC;EACC,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBE1BM;AFuBR;AAMC;EACC,aAAA;EACA,sBAAA;AAJF;AAME;EC9BD,aAAA;EACA,sBAAA;EACA,6BD6BsB;EC5BtB,uBD4BoC;EAClC,eAAA;EACA,UAAA;AADH;AAKC;EACC,sBAAA;EACA,iBAAA;AAHF;;AAOA;EC3CC,aAAA;EACA,sBAAA;EACA,2BD0CoB;ECzCpB,mBDyCgC;EAChC,SAAA;AADD;;AAIA;ECtDC,aAAA;EACA,2BDsDc;ECrDd,0BDqD0B;AAC3B;;AAEA;ECpDC,aAAA;EACA,sBAAA;EACA,2BDmDoB;EClDpB,0BDkDgC;AAIjC;;AADA;EACC,iBAAA;AAID;;AAAC;EACC,oBAAA;AAGF;AALA;EAIC,aAAA;EACC,uBAAA;EACA,8BAAA;EACA,cAAA;AAIF;;AAAC;EACC,oBAAA;AAGF;AALA;EC5EC,aAAA;EACA,2BD+Ec;EC9Ed,mBD8E0B;EAC1B,mBAAA;EACA,oBAAA;AAMD;;AAHA;;EAGC,mBAAA;AAKD;;AAFA;EACC,kBAAA;EACG,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;AAKJ;;AAFA;EACC,qBAAA;EACA,cEzGU;EF0GV,UAAA;AAKD;;AAFA;EACC,cE9GU;AFmHX;;AAFA;EACC,cElHU;AFuHX;;AAFA;EACC,oBAAA;AAKD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.web-portal {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t.form-input > input{\n\t\tpadding: 6px !important;\n\t}\n\n\t.form-check-input-custom{\n\t\tdisplay: flex;\n    align-items: center;\n\t}\n\n\t&-title {\n\t\tfont-size: 1.5em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-top: 2em;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t}\n\n\t&-form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&-layout {\n\t\t\t@include flexColumn(space-evenly, flex-start);\n\t\t\tflex-wrap: wrap;\n\t\t\tgap: .5em;\n\t\t}\n\t}\n\n\t.form-action {\n\t\talign-self: flex-start;\n\t\tmargin-top: .3em;\n\t}\n}\n\n.web-portal-access-col {\n\t@include flexColumn(flex-start, center);\n\tflex: 1;\n}\n\n.web-portal-check-group {\n\t@include flex(flex-start, space-between);\n}\n\n.web-portal-access-group-col {\n\t@include flexColumn(flex-start, space-between);\n}\n\n.web-portal-access-label {\n\tfont-weight: bold;\n}\n\n.web-portal-sr-check-group-col {\n\t.form-check {\n\t\tmargin: 0 !important;\n\t}\n\tdisplay: grid; \n  grid-auto-rows: 1fr 1fr; \n  grid-template-columns: 1fr 1fr; \n  gap: .1em 5em; \n}\n\n.web-portal-sr-check-group-col-header{\n\t.form-check {\n\t\tmargin: 0 !important;\n\t}\n\t@include flex(flex-start, center);\n\tmargin-right: .5em;\n\tmargin-bottom: .5em;\n}\n\n.web-portal-sr-check-group-col-header span,\n.web-portal-sr-check-group-col-header label\n{\t\n\twhite-space: nowrap;\n}\n\n.blocked-label{\n\tmargin-top: 0.5rem;\n    margin-left: 1rem;\n    font-size: 0.8rem;\n    color: gray;\n    padding-left: 0.3rem;\n    padding-right: 0.3rem;\n    border-radius: 0.2rem;\n    background-color: #E6E6E6;\n}\n\n.hard-delete-user-button{\n\ttext-decoration: none;\n\tcolor: $dark-red;\n\tpadding: 0;\n}\n\n.hard-delete-user-button:hover{\n\tcolor: $dark-red;\n}\n\n.hard-delete-user-button:focus{\n\tcolor: $dark-red;\n}\n\n.hard-delete-user-button  p {\n\tmargin: 0 !important;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
